
const experiments = [
    // Sample format:
    // {
    //     "id": 123,
    //     "is_active": true,
    //     "original_route": "/products/cloud-shave-foam",
    //     "redirect_route" : "/collections/all"
    // }
    //  https://athenaclub.com/discount/take5?redirect=%2Fproducts%2Frazor-kit
    {
        "id": 3,
        "original_route": "/products/razor-kit",
        "redirect_route" : "/pages/razor-kit-003",
        "is_active": false
    },
    {
        "id": 201,
        "description" : "New card with just RTC",
        "is_active": false,
    },
    {
        "id": 202,
        "description" : "Dual Cross Sell, RTC + GSS",
        "is_active": false,
    },
    {
        "id": 203,
        "description" : "Just shave butter with new card",
        "is_active": false,
    },
    {
        "id": 211,
        "description" : "Multi-step RKQUS FSB RTC",
        "is_active": false,
    },
    {
        "id": 212,
        "description" : "Multi-step RKQUS FSB GSS",
        "is_active": false,
    },
    {
        "id": 221,
        "description" : "Multi-card RKQUS preselected",
        "is_active": false,
    },
    {
        "id": 222,
        "description" : "Multi-card RKQUS unselected",
        "is_active": false,
    },
    {
        "id": 230,
        "description" : "Razor Kit Quiz Landing Page (auto opens)",
        "is_active": true,
    },
    {
        "id": 301,
        "description" : "8-H Blades Test",
        "is_active": true,
    },
    {
        "id": 302,
        "description" : "8-H Blades Test with yearly option",
        "is_active": true,
    },
    {
        "id": 303,
        "description" : "8-H Blades Test with yearly option and no price pill",
        "is_active": true,
    },
    {
        "id": 400,
        "description" : "Move cross sell up",
        "original_route": "/products/razor-kit",
        "redirect_route" : "/pages/razor-kit-400",
        "is_active": false
    },
    {
        "id": 401,
        "description" : "Mystery Gift Pop Up",
        "is_active": false,
        "opened": false,
    },
    {
        "id": 500,
        "description" : "Page PDP Control vs Real PDP Control",
        "original_route": "/products/razor-kit",
        "redirect_route" : "/pages/the-razor-kit-control",
        "is_active": false
    },
    {
        "id": 601,
        "description" : "Free deo with $20 of subtotal (in cart)",
        "free_variant_id" : 45551134638364,
        "free_product_handle" : "all-day-deo",
        "is_active": false
    },
    {
        "id": 602,
        "description" : "Free CBW with subscription razor kit",
        "free_variant_id" : 45551133950236,
        "free_product_handle" : "creamy-body-wash",
        "is_active": false
    },
    {
        "id": 701,
        "description" : "Sweatcoin Offer on Coral, Matchpoint, Mint and Lilac",
        "is_active": true,
    }
]

async function clearExpDetails(){
    localStorage.removeItem('exp_details');
    let formData = new FormData();
    formData.append("attributes[gwpFreeVarId]", null);
    formData.append("attributes[gwpFreeProdHandle]", null);
    formData.append("attributes[expID]", null);

    const cartRes = await fetch(`${window.themeVariables.routes.cartUrl}/update.js`, {
        body: formData,
        method: "POST"
    });
}

function getURLParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(window.location.search);
    return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function checkAndUpdateLocalStorage(newExp) {
    let currentExp = JSON.parse(localStorage.getItem('exp_details') ?? null)

    if(currentExp && currentExp.id === newExp.id){
        return;
    }

    localStorage.setItem('exp_details', JSON.stringify(newExp))
}

function checkForRedirect(expDetails){
    if(!expDetails.redirect_route || !expDetails.original_route){
        return;
    }

    if(expDetails.original_route == window.location.pathname){
        window.location.pathname = expDetails.redirect_route
    }
}
window.addEventListener('DOMContentLoaded', async () => {
    if(getURLParameter('clear-experiments')){
        await clearExpDetails();
        return;
    }

    let currExpId =
        getURLParameter('expid') ??
            (localStorage.getItem('exp_details') ?
                JSON.parse(localStorage.getItem('exp_details'))['id'] : null
            );

    if(!currExpId){
        return;
    }

    let newExpDetails = experiments.find((exp) => exp.id === parseInt(currExpId))

    if(!newExpDetails || (newExpDetails && !newExpDetails.is_active)){
        await clearExpDetails();
        return;
    }

    checkAndUpdateLocalStorage(newExpDetails);
    checkForRedirect(newExpDetails);
})
